import { render, staticRenderFns } from "./ApplePayButton.vue?vue&type=template&id=70e21bac"
import script from "./ApplePayButton.vue?vue&type=script&lang=js"
export * from "./ApplePayButton.vue?vue&type=script&lang=js"
import style0 from "./ApplePayButton.vue?vue&type=style&index=0&id=70e21bac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports